import Cookies from 'js-cookie';

/**
 * 主要是测试、开发环境区分
 */
export const addEnvHeader = (config) => {
    const tdeId = Cookies.get('_tde_id') || '';
    if (tdeId === '29566') {
        config.headers = {
            'X-Qbot-EnvSet': '2_10',
            ...config.headers
        };
    } else if (tdeId === '32676') {
        config.headers = {
            'X-Qbot-EnvSet': '2_11',
            ...config.headers
        };
    } else if (tdeId === '9867') {
        config.headers = {
            'X-Qbot-EnvSet': '2_9',
            ...config.headers
        };
    } else if (tdeId === '8429') {
        config.headers = {
            'X-Qbot-EnvSet': '2_3',
            ...config.headers
        };
    }
    return config;
};



// WEBPACK FOOTER //
// ./src/utils/ajax/util.js